import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index({ rootGetters }, { accountId, businessProfileId, streamTypes } = {}) {
        if (!accountId) {
            const { id: loggedUserId } = rootGetters['auth/loggedUser'];

            accountId = loggedUserId;
        }

        const params = {
            account_id: accountId
        };

        if (businessProfileId) {
            params.business_profile_id = businessProfileId;
        }

        if (Array.isArray(streamTypes)) {
            params.stream_types = streamTypes;
        }

        return axios.$get('/v1/streams', {
            params
        });
    }
};
